/** @module ActionTypes */

// card actions
export const ADD_CARDS = "ADD_CARDS";
export const ADD_DECK = "ADD_DECK";
export const TAKE_CARD = "TAKE_CARD";
export const DISCARD_CARD = "DISCARD_CARD";
export const SET_CARD_GRID = "SET_CARD_GRID";

// flag actions
export const TOGGLE_FLAGS = "TOGGLE_FLAGS";
export const SET_RUN_COUNTER = "SET_RUN_COUNTER";
export const SET_RELATIVES_COUNTER = "SET_RELATIVES_COUNTER";
export const SET_ERUPTION_COUNTER = "SET_ERUPTION_COUNTER";

// game play actions
export const ADD_RECOMMENDATIONS = "ADD_RECOMMENDATIONS";
export const SET_PLACED_RELATIVES = "SET_PLACED_RELATIVES";
export const SELECT_PERSON = "SELECT_PERSON";

// grid actions
export const ADD_GRID = "ADD_GRID";
export const PLACE_PEOPLE = "PLACE_PEOPLE";
export const PLACE_LAVA = "PLACE_LAVA";
export const UPDATE_DISTANCE_TO_EXIT = "UPDATE_DISTANCE_TO_EXIT";
export const SET_DANGER_ZONE = "SET_DANGER_ZONE";
export const SET_RUN_ZONE = "SET_RUN_ZONE";
export const SET_RUN_FROM_SQUARE = "SET_RUN_FROM_SQUARE";
export const SET_RUNNER = "SET_RUNNER";

// message actions
export const SET_STAGE = "SET_STAGE";
export const UPDATE_INSTRUCTIONS = "UPDATE_INSTRUCTIONS";

// player actions
export const SET_PLAYERS_ARRAY = "SET_PLAYERS_ARRAY";
export const ADD_PLAYERS = "ADD_PLAYERS";
export const ADD_PLAYER = "ADD_PLAYER";
export const UPDATE_PLAYER_HAND = "UPDATE_PLAYER_HAND";
export const SET_PLAYER_TURN = "SET_PLAYER_TURN";
export const INCREMENT_PLAYER_POPULATION = "INCREMENT_PLAYER_POPULATION";
export const INCREMENT_PLAYER_CASUALTIES = "INCREMENT_PLAYER_CASUALTIES";
export const INCREMENT_PLAYER_SAVED = "INCREMENT_PLAYER_SAVED";
export const SET_ACTIVE_PLAYER = "SET_ACTIVE_PLAYER";
export const SAVE_GAME_SETTINGS = "SAVE_GAME_SETTINGS";

// snackbar actions
export const ADD_SNACKBAR = "ADD_SNACKBAR";

// tiles actions
export const ADD_TILES = "ADD_TILES";
export const ADD_TILE_PILE = "ADD_TILE_PILE";
export const TAKE_TILE = "TAKE_TILE";
export const SET_LAVA_TILE = "SET_LAVA_TILE";
